(function () {
function $4937a915b72f1eb1$export$2e2bcd8739ae039() {
    // 'colocar scripts das respectivas paginas dentro de -scriptsPaginas-  e criar o arquivo exemplo: home.js - contato.js  --- e importar no main e executar em sua respectiva pagina '
    function swiperInit() {
        const swiperBanner = new Swiper(".swiper-banner", {
            spaceBetween: 30,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 4000
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            on: {
                init: function(e) {
                    const { slides: slides, realIndex: realIndex, previousIndex: previousIndex } = e;
                    const el = slides[realIndex].querySelector("img");
                    anime(el, 80);
                }
            }
        });
        function anime(el, x, els) {
            const isMobile = window.matchMedia("(min-width: 768px)").matches;
            gsap.set(el, {
                scale: 1.15,
                x: isMobile ? x : 0
            });
            // if (els) els.forEach(i => gsap.set(i, {}))
            gsap.timeline().to(el, {
                clearProps: "all",
                scale: 1.1,
                x: 0,
                duration: 15,
                ease: "power1.out",
                overwrite: true
            });
        }
        swiperBanner.on("activeIndexChange", function(e) {
            const { slides: slides, realIndex: realIndex, previousIndex: previousIndex } = e;
            let x = 80;
            if (Math.random() > 0.5) x = 80;
            else x = -80;
            if (previousIndex > realIndex) x = -80;
            const el = slides[realIndex].querySelector("img");
            console.log("slide changed", {
                e: e
            });
            anime(el, x, slides);
        });
    }
    function addClass() {
        document.body.classList.add("animate-end");
    }
    ///Animation
    const banner = document.querySelector("#banner"), logoAnimada = document.querySelector("#banner .logo-animada"), bannerWrapper = document.querySelector(".swiper-wrapper-1"), menuBtn = document.querySelector(".hamburger-menu"), logoBranca = document.querySelector(".img-branco.logo-img"), menuContato = document.querySelector("#banner .btn-show"), logoArquitetos = document.querySelector(".arquitetos");
    const mobile = window.matchMedia("(max-width: 768px)").matches;
    const y = 200, inset0 = "inset(0% 0% 0% 0%)", clipBanner = mobile ? "inset(20px 20px 20px 20px)" : "inset(50px 50px 50px 50px)";
    const tl = gsap.timeline({
        paused: true
    }) //
    .set(banner, {
        clipPath: inset0
    }).set(menuBtn, {
        opacity: 0
    }).set(menuContato, {
        opacity: 0
    }).set(logoBranca, {
        opacity: 0
    }).set(logoArquitetos, {
        y: y
    }).set([
        logoArquitetos,
        logoBranca
    ], {
        opacity: 0
    })// .set(bannerWrapper, {yPercent:100})
    .set(bannerWrapper, {
        display: "flex"
    }).to(logoAnimada, {
        x: 0,
        y: 0,
        ease: "sine.out",
        duration: 0.45
    }, "+=3.1").call(swiperInit).to(banner, {
        clipPath: clipBanner,
        duration: 0.6,
        ease: "expo.inOut"
    }, "-=0.2").to(bannerWrapper, {
        y: 0,
        scale: 1,
        ease: "expo.inOut",
        duration: 2.6
    }, "juntos-=1").set([
        logoArquitetos
    ], {
        opacity: 1
    }, "juntos+=0.1").to(logoBranca, {
        opacity: 1,
        duration: 0.3
    }, "juntos+=0.1").to(logoArquitetos, {
        y: 0,
        ease: "expo.out",
        duration: 2.3
    }, "juntos+=0.3").to(menuBtn, {
        opacity: 1,
        duration: 1,
        ease: "expo.out"
    }, "juntos+=1").to(menuContato, {
        opacity: 1,
        duration: 1,
        ease: "expo.out"
    }, "juntos+=1").set(logoAnimada, {
        display: "none"
    }, mobile ? "juntos" : "juntos+=1").call(addClass);
    tl.play();
    window.tl = tl;
} /* 

  const tl = gsap
    .timeline({ paused: true }) //
    // .call(, null)

    .set(banner, { clipPath: "inset(0% 0% 0% 0%)" })
    .set(menuBtn, { opacity: 0 })
    .set(logoAnimada, { clipPath: "inset(0% 0% 0% 0%)" })
    // .set(bannerWrapper, { yPercent: 100 })
    .to(logoAnimada, { duration: 0.45, x: 0, y: 0, ease: "sine.out" }, "+=3.1")
    .to(banner, { clipPath: "inset(50px 50px 50px 50px)", duration: 0.2 }, "+=0.1")
    .call(swiperInit)
    .set(bannerWrapper, { opacity: 1 })
    // .to(fundo, { yPercent: -100, ease: "expo.inOut", duration: 1.5 }, "juntos-=0.3")
    .to(bannerWrapper, { y: 0, ease: "expo.inOut", duration: 2.2 }, "juntos-=0.3")
    // .to(
    //   logoAnimada,
    //   { clipPath: "inset(0% 0% 100% 0%)", duration: 0.25, ease: "linear" },
    //   "juntos+=0.16"
    // )
    .to(menuBtn, { opacity: 1 }, "juntos+=0.4");
  // .call(hideElements);

  // tl.timeScale(0.5).play();
  tl.play();
  // .to(menuBtn, { opacity: 1 }, "juntos+=0.4");

  //falta ocultar o menu e contato dps aparecer
  window.tl = tl;
*/ 


function $e8eee3c5dbb450bf$export$2e2bcd8739ae039() {
    const swiperInit = ()=>new Swiper(".mySwiper", {
            slidesPerView: 2,
            spaceBetween: 25,
            observer: true,
            updateOnWindowResize: true,
            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true
            },
            grid: {
                rows: 2
            },
            breakpoints: {
                640: {
                    slidesPerView: 2
                },
                955: {
                    slidesPerView: 3
                },
                1224: {
                    slidesPerView: 4
                },
                1650: {
                    slidesPerView: 5
                },
                2150: {
                    slidesPerView: 6
                }
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });
    var swiper = swiperInit();
    window.swiperProjetos = swiper;
    window.swiperInit = swiperInit;
    window.addEventListener("resize", ()=>{
        swiper.destroy();
        setTimeout(()=>swiperInit(), 100);
    });
    const mobile = window.matchMedia("(max-width:780px)").matches;
    if (mobile) {
        const menuToggle = document.querySelector(".menu-toggle");
        const menu = document.querySelector(".menu");
        if (menuToggle) {
            menuToggle.classList.remove('open');
            menu.classList.remove('open');
        }
    }
}


function $3cdd26e8a4be1ca4$export$2e2bcd8739ae039() {}


function $08a0bb1a2b8dee1f$export$2e2bcd8739ae039() {}


function $6074568c9c4450be$export$2e2bcd8739ae039() {
    const attr = "[js-password]";
    const divs = document.querySelectorAll(`.show-password${attr}`);
    if (!divs.length) return;
    function handleEvent(div) {
        return function(event) {
            let input = div.querySelector("[js-input-password]");
            let item = event.currentTarget;
            input.type = input.type == 'text' ? 'password' : 'text';
            if (input.type == 'text') item.classList.add("mostra");
            else item.classList.remove("mostra");
        };
    }
    divs.forEach((div)=>{
        const buttonPass = div.querySelector('.password');
        buttonPass.addEventListener('click', handleEvent(div));
    });
}


function $2914c72b259257f0$export$2e2bcd8739ae039() {
    const allFormsErrors = document.querySelectorAll("[id^='form-errors']");
    allFormsErrors.forEach((formErrors)=>showErrors(formErrors));
    function showErrors(formErrors) {
        const errorsText = formErrors.textContent;
        const errors = JSON.parse(errorsText).__all__;
        errors && errors.forEach((error)=>error ? GLOBAL.showToastify(error) : "");
    }
}


function $dde89147b3a6dc75$export$2e2bcd8739ae039() {
    const menuToggle = document.querySelector(".menu-toggle");
    const menu = document.querySelector(".menu");
    const imgAzul = document.querySelectorAll(".img-branco");
    const body = document.body;
    const mobile = window.matchMedia("(max-width:780px)").matches;
    if (menuToggle) menuToggle.addEventListener("click", ()=>{
        menuToggle.classList.toggle("open");
        menu.classList.toggle("open");
        body.classList.toggle("open-menu");
        imgAzul.forEach((item)=>item.classList.toggle("open"));
    });
    if (mobile) {
        const menuToggle = document.querySelector(".menu-toggle");
        const menu = document.querySelector(".menu");
        if (menuToggle && menu) {
            menuToggle.classList.remove("open");
            menu.classList.remove("open");
        }
    }
}


function $1919445fc9aeb913$export$2e2bcd8739ae039() {
    const mySwiper1 = new Swiper(".mySwiper1", {
        slidesPerView: 1.2,
        spaceBetween: 25,
        freeMode: false,
        autoplay: {
            delay: 3000
        },
        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true
        },
        breakpoints: {
            640: {
                slidesPerView: 2.2
            },
            768: {
                spaceBetween: 25
            },
            1224: {
                spaceBetween: 100
            },
            1300: {
                slidesPerView: 2.5,
                spaceBetween: 179
            }
        }
    });
    const mySwiper2 = new Swiper(".mySwiper2", {
        slidesPerView: 1.2,
        spaceBetween: 25,
        freeMode: false,
        autoplay: {
            delay: 3000
        },
        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true
        },
        breakpoints: {
            640: {
                slidesPerView: 2.2
            },
            768: {
                slidesPerView: 2.5
            },
            1224: {
                slidesPerView: 2.7
            },
            1300: {
                slidesPerView: 3.5
            }
        }
    });
    const mySwiper3 = new Swiper(".mySwiper3", {
        slidesPerView: 0.5,
        spaceBetween: 25,
        freeMode: false,
        autoplay: {
            delay: 3000
        },
        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true
        },
        breakpoints: {
            640: {
                slidesPerView: 1.5
            }
        }
    });
    const mySwiper4 = new Swiper(".mySwiper4", {
        // slidesPerView: 2.5,
        slidesPerView: "auto",
        spaceBetween: 25,
        freeMode: false,
        autoplay: {
            delay: 3000
        },
        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true
        },
        breakpoints: {
            640: {
                // slidesPerView: 2.2,
                slidesPerView: "auto"
            },
            768: {
                slidesPerView: 2.5
            },
            1224: {
                slidesPerView: 2.7
            },
            1300: {
                slidesPerView: 3.2
            }
        }
    });
    const mySwiper5 = new Swiper(".mySwiper5", {
        slidesPerView: 5,
        spaceBetween: 25,
        freeMode: false,
        autoplay: {
            delay: 3000
        },
        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true
        },
        breakpoints: {
            640: {
                // slidesPerView: 1.5,
                slidesPerView: "auto"
            }
        }
    });
    const mySwiper6 = new Swiper(".mySwiper6", {
        // slidesPerView: 2.5,
        slidesPerView: 1,
        spaceBetween: 25,
        freeMode: false,
        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true
        },
        autoplay: {
            delay: 3000
        },
        breakpoints: {
            640: {
                slidesPerView: 2.5
            }
        }
    });
    const swippers3x = document.querySelectorAll(".mySwiper3x");
    swippers3x?.forEach((swiper)=>swiper.insertAdjacentHTML("beforeend", `   <div class="swiper-btns">
                <div class="swiper-button-next">
                    <svg class=''>
                        <use xlink:href='#icon_seta'></use>
                    </svg>
                </div>
                <div class="swiper-button-prev">
                    <svg class=''>
                        <use xlink:href='#icon_seta'></use>
                    </svg>
                </div>
            </div>`));
    swippers3x?.forEach((swiper)=>{
        const mySwiper3x = new Swiper(swiper, {
            slidesPerView: "auto",
            spaceBetween: 25,
            freeMode: false,
            // centeredSlides:true,
            // initialSlide:0,
            navigation: {
                nextEl: swiper?.querySelector(".swiper-button-next"),
                prevEl: swiper?.querySelector(".swiper-button-prev")
            },
            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true
            },
            autoplay: {
                delay: 3000
            },
            breakpoints: {
            }
        });
    });
    const mySwiper3x = new Swiper(".mySwiper4x", {
        slidesPerView: "auto",
        spaceBetween: 25,
        freeMode: false,
        updateOnWindowResize: true,
        simulateTouch: true,
        // centeredSlides:true,
        // initialSlide:0,
        // navigation: {
        //   nextEl: swiper?.querySelector(".swiper-button-next"),
        //   prevEl: swiper?.querySelector(".swiper-button-prev"),
        // },
        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true
        },
        autoplay: {
            delay: 3000
        },
        breakpoints: {
        }
    });
// debugger
}


function $4833981fa71a468d$export$2e2bcd8739ae039() {
    const breakpoint = window.matchMedia("(min-width:1024px)");
    let swiperPortfolio;
    const breakpointChecker = function() {
        if (breakpoint.matches === true) {
            if (swiperPortfolio !== undefined) swiperPortfolio.destroy(true, true);
            return;
        } else if (breakpoint.matches === false) return enableSwiper();
    };
    const enableSwiper = function() {
        swiperPortfolio = new Swiper(".swiper-portfolio", {
            slidesPerView: 1.2,
            spaceBetween: 8,
            loop: true,
            speed: 10000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false
            },
            pagination: {
                el: "#portfolio .swiper-pagination",
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 8
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 8
                }
            }
        });
    };
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
}


function $95d9606b27337514$export$2e2bcd8739ae039() {
    const swiperServicosSobre = new Swiper(".swiper-servicos-sobre", {
        slidesPerView: 2.5,
        spaceBetween: 16,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        },
        pagination: {
            el: "#sobre .swiper-pagination",
            clickable: true
        },
        breakpoints: {
            640: {
                slidesPerView: 4.2,
                spaceBetween: 16
            },
            768: {
                slidesPerView: 5.2,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 7,
                spaceBetween: 16
            }
        }
    });
}


function $6ee3df27c4589396$export$2e2bcd8739ae039() {
    const swiperClientes = new Swiper(".swiper-clientes:not(.linha-2)", {
        slidesPerView: 2,
        spaceBetween: 16,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 16
            },
            1900: {
                slidesPerView: 5,
                spaceBetween: 16
            }
        }
    });
    const swiperClientes2 = new Swiper(".swiper-clientes.linha-2", {
        slidesPerView: 2,
        spaceBetween: 16,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: true
        },
        breakpoints: {
            768: {
                slidesPerView: 3.5,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 16
            },
            1900: {
                slidesPerView: 4,
                spaceBetween: 16
            }
        }
    });
}


function $97eee76bf2396f98$export$2e2bcd8739ae039() {
    const contatoFormSubmit = document.querySelector('#form-submit');
    contatoFormSubmit && contatoFormSubmit.addEventListener('submit', function(event) {
        event.preventDefault();
        disabledBtn();
        const form_data = {
            nome: document.querySelector('#nome').value,
            email: document.querySelector('#email').value,
            telefone: document.querySelector('#telefone').value,
            mensagem: document.querySelector('#mensagem').value
        };
        const url = "/fale-conosco/";
        axios.post(url, form_data).then((response)=>showMessage(response)).catch((response)=>showMessage(response));
    });
    function showMessage(response) {
        const message = response.data ? response.data.message : response.message;
        GLOBAL.showToastify(message);
        contatoFormSubmit.reset();
        setTimeout(enabledBtn, 1000);
    }
    const btnSubmit = document.querySelector(".btn");
    function disabledBtn() {
        btnSubmit.disabled = true;
        btnSubmit.classList.add("disabled");
    }
    function enabledBtn() {
        btnSubmit.disabled = false;
        btnSubmit.classList.remove("disabled");
    }
}


function $e036cb5309760360$export$2e2bcd8739ae039() {
    const section = document.querySelector("[js-mais-projetos]");
    if (!section) return;
    const slides = section.querySelectorAll(".swiper-slide .projeto-wrapper");
    slides.forEach((slide)=>{
        const path = window.location.pathname;
        if (slide.href.includes(path)) slide.closest(".swiper-slide").remove();
    });
}


// PAGES
const $ad253d60d7afe5ec$var$pageHome = document.querySelector(".page__home");
const $ad253d60d7afe5ec$var$pageProjetos = document.querySelector(".page__projetos");
const $ad253d60d7afe5ec$var$pageContato = document.querySelector(".page__contato");
const $ad253d60d7afe5ec$var$pageSobre = document.querySelector(".page__sobre");
const $ad253d60d7afe5ec$var$AguaSumida = document.querySelector(".page__agua_sumida");
const $ad253d60d7afe5ec$var$xangriLa = document.querySelector(".page__xangri_la");
const $ad253d60d7afe5ec$var$eixao = document.querySelector(".page__eixao");
const $ad253d60d7afe5ec$var$basalto = document.querySelector(".page__basalto");
const $ad253d60d7afe5ec$var$vistavino = document.querySelector(".page__vistavino");
const $ad253d60d7afe5ec$var$aptAmerica = document.querySelector(".page__apt_america");
const $ad253d60d7afe5ec$var$lajeado = document.querySelector(".page__lajeado");
const $ad253d60d7afe5ec$var$celeiro = document.querySelector(".page__celeiro");
const $ad253d60d7afe5ec$var$ecletica = document.querySelector(".page__ecletica");
// const rui_barbosa = document.querySelector(".page__rui_barbosa");
(0, $e036cb5309760360$export$2e2bcd8739ae039)();
(0, $6074568c9c4450be$export$2e2bcd8739ae039)();
(0, $2914c72b259257f0$export$2e2bcd8739ae039)();
(0, $dde89147b3a6dc75$export$2e2bcd8739ae039)();
(0, $1919445fc9aeb913$export$2e2bcd8739ae039)();
(0, $4833981fa71a468d$export$2e2bcd8739ae039)();
(0, $95d9606b27337514$export$2e2bcd8739ae039)();
(0, $6ee3df27c4589396$export$2e2bcd8739ae039)();
(0, $97eee76bf2396f98$export$2e2bcd8739ae039)();
// ★ Pages Scopo
if ($ad253d60d7afe5ec$var$pageHome) {
    // ★ HOME
    document.body.classList.add("body__home");
    (0, $4937a915b72f1eb1$export$2e2bcd8739ae039)();
}
if ($ad253d60d7afe5ec$var$pageProjetos) {
    // ★ HOME
    document.body.classList.add("page__projetos");
    (0, $e8eee3c5dbb450bf$export$2e2bcd8739ae039)();
}
if ($ad253d60d7afe5ec$var$pageContato) {
    // ★ HOME
    document.body.classList.add("page__contato");
    (0, $3cdd26e8a4be1ca4$export$2e2bcd8739ae039)();
}
if ($ad253d60d7afe5ec$var$pageSobre) {
    // ★ HOME
    document.body.classList.add("page__sobre");
    (0, $08a0bb1a2b8dee1f$export$2e2bcd8739ae039)();
}
if ($ad253d60d7afe5ec$var$AguaSumida) // ★ HOME
document.body.classList.add("page__agua_sumida");
if ($ad253d60d7afe5ec$var$xangriLa) // ★ HOME
document.body.classList.add("page__xangri_la");
if ($ad253d60d7afe5ec$var$eixao) // ★ HOME
document.body.classList.add("page__eixao");
if ($ad253d60d7afe5ec$var$basalto) // ★ HOME
document.body.classList.add("page__basalto");
if ($ad253d60d7afe5ec$var$vistavino) // ★ HOME
document.body.classList.add("page__vistavino");
if ($ad253d60d7afe5ec$var$aptAmerica) // ★ HOME
document.body.classList.add("page__apt_america");
if ($ad253d60d7afe5ec$var$lajeado) // ★ HOME
document.body.classList.add("page__lajeado");
if ($ad253d60d7afe5ec$var$celeiro) // ★ HOME
document.body.classList.add("page__celeiro");
if ($ad253d60d7afe5ec$var$ecletica) // ★ HOME
document.body.classList.add("page__ecletica");
document.addEventListener("DOMContentLoaded", ()=>document.body.classList.add("dcl"));

})();
//# sourceMappingURL=main.js.map
